// exportToExcel.js
import * as XLSX from 'xlsx'; // Import the XLSX library

const formatTitle = (title) => {
  // Definir una lista de conectores comunes que se deben eliminar
  const connectors = ["de", "a", "la", "el", "los", "las", "y", "en"];

  // Convertir el título a mayúsculas, eliminar caracteres no alfanuméricos excepto espacios y dividir en palabras
  let words = title.toUpperCase().replace(/[^A-Z0-9\s]/g, "").split(" ");

  // Filtrar las palabras que no sean conectores y obtener las tres primeras letras de cada una
  let initials = words.filter(word => !connectors.includes(word.toLowerCase())).map(word => word.slice(0, 3));

  // Unir las iniciales con guiones bajos
  let formattedTitle = initials.join("_");

  // Limitar el título a 31 caracteres contando desde el final
  if (formattedTitle.length > 31) {
    formattedTitle = formattedTitle.slice(-31);
  }

  return formattedTitle;
};

const exportToExcel = (title, exportData, columns) => {
  const formattedTitle = formatTitle(title);

  // Crear una hoja de trabajo a partir de los datos
  const worksheetData = exportData.map(item =>
    columns.reduce((acc, col) => {
      acc[col.header] = item[col.field];
      return acc;
    }, {})
  );

  const worksheet = XLSX.utils.json_to_sheet(worksheetData);

  // Agregar nombres de columnas a la hoja de trabajo
  const columnNames = columns.map(col => col.header);
  XLSX.utils.sheet_add_aoa(worksheet, [columnNames], { origin: 'A1' });

  // Aplicar estilos a la primera fila
  const range = XLSX.utils.decode_range(worksheet['!ref']);
  for (let C = range.s.c; C <= range.e.c; ++C) {
    const cellAddress = XLSX.utils.encode_cell({ c: C, r: 0 });
    if (!worksheet[cellAddress]) continue;
    worksheet[cellAddress].s = {
      fill: {
        patternType: 'solid',
        fgColor: { rgb: "0000FF" } // Azul
      },
      font: {
        color: { rgb: "FFFFFF" }, // Blanco
        bold: true
      },
      alignment: {
        horizontal: 'center'
      }
    };
  }

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, formattedTitle);
  XLSX.writeFile(workbook, `${formattedTitle}.xlsx`);
};

export default exportToExcel;
